import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { MenuItem } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { AppSessionService } from '../../../../../shared/session/app-session.service';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, MenuItemComponent, RouterModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  model: MenuItem[] = [];
  adminModel: MenuItem[] = [];
  reservedAreaModel: MenuItem[] = [];

  private readonly _appSessionService = inject(AppSessionService);

  ngOnInit() {
    this.model = [
      {
        items: [
          {
            label: 'Home Page',
            icon: 'pi pi-home',
            routerLink: ['/home/info']
          }
        ]
      },
      {
        items: [
          {
            label: 'Museo Virtuale',
            icon: 'pi pi-building-columns',
            routerLink: ['/home/museo-virtuale']
          },
          {
            label: 'Pianta interattiva',
            icon: 'pi pi-map',
            routerLink: ['/home/mappe']
          },
          {
            label: 'Galleria Fotografica',
            icon: 'pi pi-camera',
            routerLink: ['/home/galleria-fotografica']
          },
          {
            label: 'Scavo 3D',
            icon: 'pi pi-image',
            routerLink: ['/home/scavo-3d']
          }
        ]
      }
    ];

    this.adminModel = [
      {
        items: [
          {
            label: 'Amministrazione',
            icon: 'pi pi-id-card',
            routerLink: ['/home/amministrazione'],
            disabled: true,
            items: [
              {
                label: 'Gestione Utenti',
                routerLink: ['/home/amministrazione/gestione-utenti'],
              },
              {
                label: 'Tipologiche',
                routerLink: ['/home/amministrazione/tipologiche'],
                disabled: true,
                items: [
                  {
                    label: 'Tipi Materiali',
                    routerLink: ['/home/amministrazione/tipologiche/tipi-materiali'],
                  },
                  {
                    label: 'Tipi Classe',
                    routerLink: ['/home/amministrazione/tipologiche/tipi-classi'],
                  },
                  {
                    label: 'Tipi Decorazioni',
                    routerLink: ['/home/amministrazione/tipologiche/tipi-decorazioni'],
                  },
                  {
                    label: 'Tipi Forme',
                    routerLink: ['/home/amministrazione/tipologiche/tipi-forme'],
                  },
                  {
                    label: 'Tipi Unità Stratigrafiche',
                    routerLink: ['/home/amministrazione/tipologiche/tipi-unita-stratigrafica'],
                  },
                  {
                    label: 'Tipi Affidabilità Stratigrafiche',
                    routerLink: ['/home/amministrazione/tipologiche/tipi-affidabilita-stratigrafiche'],
                  },
                  {
                    label: 'Tipi Tecnica Lavorazione',
                    routerLink: ['/home/amministrazione/tipologiche/tipi-inv-tecnica-lavorazione'],
                  },
                ],
              },
              {
                label: 'Gestione Unità Stratigrafiche',
                routerLink: ['/home/amministrazione/gestione-unita-stratigrafiche'],
              },
              {
                label: 'Gestione Museo Virtuale',
                disabled: true,
                routerLink: ['/home/amministrazione/gestione-museo-virtuale'],
                items: [
                  {
                    label: 'Gestione Sezioni',
                    routerLink: ['/home/amministrazione/gestione-museo-virtuale/gestione-sezioni'],

                  },
                  {
                    label: 'Gestione Macro Tematiche',
                    routerLink: ['/home/amministrazione/gestione-museo-virtuale/gestione-macro-tematiche'],
                  }
                ]
              },
              {
                label: 'Gestione Mappe',
                disabled: true,
                routerLink: ['/home/amministrazione/gestione-mappe'],
              },
              {
                label: 'Gestione Galleria Fotografica',
                disabled: true,
                routerLink: ['/home/amministrazione/gestione-galleria-fotografica'],
              },
              {
                label: 'Gestione Scavo 3D',
                disabled: true,
                routerLink: ['/home/amministrazione/gestione-scavo-3d'],
              },


            ]
          },
        ],
      }
    ];

    this.reservedAreaModel = [
      {
        items: [
          {
            label: 'Area Riservata',
            icon: 'pi pi-users',
            routerLink: ['/account/login'],
          }
        ]
      }
    ]

  }


  isLoggedIn(): boolean {
    return this._appSessionService.userInfo !== undefined && this._appSessionService.userInfo !== null;
  }
}
